export * from './domain/software';
export * from './mapping/mapSoftware';
export * from './remote/software';
